var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import $ from 'jquery';
import { debounce } from 'helpful-decorators';
export default class GiftClaimSummary {
    static $element = $('.js__gift-claim-summary');
    static $spinner = $('.js__gift-claim-summary-spinner');
    static $error = $('.js__gift-claim-summary-error');
    static itemVariantSelector = '.js__gift-claim-summary-item-variant';
    static itemQuantitySelector = '.js__gift-claim-summary-item-quantity';
    static url = GiftClaimSummary.$element.data('url');
    static token = GiftClaimSummary.$element.data('token');
    static request;
    static init() {
        if (!this.$element.length) {
            return;
        }
        this.trackChanges();
        this.updateOrderSummary();
    }
    static trackChanges() {
        $(document).on('change', `${this.itemVariantSelector}`, () => {
            this.updateOrderSummary();
        });
        $(document).on('input', this.itemQuantitySelector, () => {
            this.updateOrderSummary();
        });
    }
    static updateOrderSummary() {
        const formData = this.getFormData();
        if (formData === null) {
            return;
        }
        if (this.request) {
            this.request.abort();
        }
        this.$spinner.show();
        this.request = $.post(this.url, formData, null, 'html')
            .done(response => {
            this.$error.hide();
            this.$element.html(response);
        })
            .fail(() => {
            this.$element.empty();
            this.$error.show();
        })
            .always(() => {
            this.$spinner.hide();
        });
    }
    static getFormData() {
        const $variant = $(this.itemVariantSelector);
        const $quantity = $(this.itemQuantitySelector);
        if (!$variant.val() || !$quantity.val()) {
            return null;
        }
        return {
            prizeVariant: $variant.val(),
            quantity: $quantity.val(),
            _token: this.token,
        };
    }
}
__decorate([
    debounce(1000, { leading: true })
], GiftClaimSummary, "updateOrderSummary", null);
